import React, { useEffect } from 'react';

import { Redirect, useHistory } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { routes } from 'lane-shared/config';
import getContentChannelIntegration from 'lane-shared/helpers/integrations/getContentChannelIntegration';
import { GetActivateConnectionIdDocument } from 'graphql-query-contracts';
import { useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';

import { datadogRum } from '@datadog/browser-rum';

import useIsAdminView from 'hooks/useIsAdminView';
import { constructOIDCRedirectUrl } from 'lane-shared/helpers/integrations/OIDC/definition';

export default function OidcWebviewPage({ content }: any) {
  const history = useHistory();
  const [isAdminView] = useIsAdminView();
  const isOIDCConnectionFFEnabled = useFlag(
    FeatureFlag.UseOIDCConnectionParameter,
    false
  );

  const { data, loading } = useQuery(getContentChannelIntegration, {
    variables: { id: content._id },
    fetchPolicy: 'network-only',
  });

  const { data: connectionData, loading: connectionLoading } = useQuery(
    GetActivateConnectionIdDocument,
    {
      skip: !isOIDCConnectionFFEnabled || loading || !data,
    }
  );

  const connectionId = connectionData?.getActivateConnectionId?.connectionId;

  const oidcRedirectUrl = constructOIDCRedirectUrl({
    integrationId: data?.me?.content?.integration?._id,
    thirdPartyRedirectUrl:
      data?.me?.content?.integration?.settings?.redirectURL,
    connection: isOIDCConnectionFFEnabled ? connectionId : undefined,
  });

  useEffect(() => {
    const actionPayload = {
      isAdminView,
      loading,
      hasData: !!data,
      hasRedirectUrl: !!oidcRedirectUrl,
      connectionLoading,
      connectionId: connectionId ?? null,
      oidcRedirectUrl: oidcRedirectUrl ?? null,
      isOIDCConnectionFFEnabled,
    };

    if (isAdminView || loading || !data || !oidcRedirectUrl) {
      return;
    }

    if (isOIDCConnectionFFEnabled && connectionLoading) {
      return;
    }

    datadogRum.addAction('oidc_webview_redirect', actionPayload);
    window.open(oidcRedirectUrl, '_blank');
    history.goBack();
  }, [
    loading,
    connectionLoading,
    data,
    connectionId,
    oidcRedirectUrl,
    isAdminView,
    history,
    isOIDCConnectionFFEnabled,
  ]);

  if (!loading && !data) {
    return (
      <Redirect
        to={{
          pathname: `${routes.identifier}?
            contentPath=${routes.content.replace(':id', content._id)}`,
        }}
      />
    );
  }

  return null;
}
